import { MsgTemplate } from '../../schema/message/inferface';

export const getTextTemplate = (text: string): MsgTemplate => {
  return {
    text: {
      params: [],
      components: [{ type: 'BODY', text: text }],
    },
  };
};
